import app from '@/common/public.js';
import { request } from '@/api/index.js';
import {
  frequentlyUsedBusinessIndex,
  frequentlyUsedCityList,
  frequentlyUsedBusinessList,
  frequentlyUsedBusinessDelete,
  frequentlyUsedBusinessAdd,
  frequentlyUsedBusinessSearch,
} from '@/api/platform/tripwise-m.js';
import { getPublicLocation } from '@/utils/position';
import { apiName } from '@/common/config.js';
import store from '@/store/index.js';

// 添加常用
export function frequentlyUsedAdd(params, msg) {
  return new Promise((resolve, reject) => {
    let config = { notNeedAbort: true };
    request({ apiName: frequentlyUsedBusinessAdd, params, config })
      .then((res) => {
        if (app.GetResultState(res)) {
          app.Toast(msg || '已设为常用');
          resolve();
        } else {
          app.Toast(res.message);
        }
      })
      .catch((e) => {
        app.Toast(e.message);
        reject(e);
      });
  });
}

// 常用城市
export function frequentlyCityList(params) {
  return request({ apiName: frequentlyUsedCityList, params });
}
// 各个业务线首页
export function frequentlyUsedIndex(params) {
  return request({ apiName: frequentlyUsedBusinessIndex, params });
}
// 常用-酒店-航班-乘车-用车 -列表
export function frequentlyUsedList(params) {
  return request({ apiName: frequentlyUsedBusinessList, params });
}
// 业务线搜索-酒店-航班-乘车-用车 -列表
export function frequentlyUsedSearch(params) {
  return request({ apiName: frequentlyUsedBusinessSearch, params });
}

// 获取更新常用定位信息
export function updateCommonlyUsedCityData() {
  getPublicLocation()
    .then((res) => {
      let coordType = 'wgs84';



      let param = {
        CoordType: res.type || coordType,
        CurrentLat: res.latitude,
        CurrentLon: res.longitude,
        ProductType: 1,
      };
      app.Post(
        apiName.GetCommonCurrentLocation,
        param,
        (data) => {
          if (app.GetResultState(data)) {
            if (data.Result) {
              store.commit('common/setCommonlyUsedCityData', data.Result);
            } else {
              store.commit('common/setCommonlyUsedCityData', null);
            }
          } else {
            store.commit('common/setCommonlyUsedCityData', null);
          }
        },
        null,
        true,
      );
    })
    .catch(() => {
      store.commit('common/setCommonlyUsedCityData', null);
    });
}
